import { PortableText } from "@portabletext/react";
import type { ComponentProps } from "react";

export const SanityText: React.FC<{
  content: ComponentProps<typeof PortableText>["value"] | null | undefined;
}> = ({ content }) => {
  return (
    <PortableText
      value={content ?? []}
      components={{
        block: {
          normal: ({ children }) => <p style={{ minHeight: "1lh" }}>{children}</p>,
          h1: ({ children }) => <h1 className="font-bold">{children}</h1>,
          h2: ({ children }) => <h2 className="font-bold">{children}</h2>,
          h3: ({ children }) => <h3 className="font-bold">{children}</h3>,
          h4: ({ children }) => <h4 className="font-bold">{children}</h4>,
          h5: ({ children }) => <h5 className="font-bold">{children}</h5>,
          h6: ({ children }) => <h6 className="font-bold">{children}</h6>,
        },
      }}
    />
  );
};
